export default __webpack_public_path__ + "static/media/336-mark.d984066f.svg";